export default {"src":"/_next/static/media/WhoWeAre_022A.98a8749d.JPG","height":694,"width":1920};